import { useTranslation } from "react-i18next";
import { invitationLink, type IssuedInvitation } from "../../../api/invitationsApi";
import { formatDateTime } from "../../../shared/formatting/dateTimes";
import CopyReference from "../../../ui/content/CopyReference";
import { FORM_CONTROL_CLASS, FORM_HELP_TEXT_CLASS } from "../../../ui/styles/formStyles";

interface InvitationLinkProps {
  issued: IssuedInvitation;
  /** Off where several links show together and the note shows once beneath them. */
  withNote?: boolean;
}

/** An issued invitation's acceptance link, shown once for the inviter to send on: DMW sends no mail yet (F-11). */
export default function InvitationLink({ issued, withNote = true }: InvitationLinkProps) {
  const { t, i18n } = useTranslation();
  const link = invitationLink(issued.acceptanceToken, window.location.origin);
  return (
    <div className="app-card-muted space-y-2 p-3 text-sm" role="status">
      <p>{t("projects.invitation.issued", { email: issued.email, expiresAt: formatDateTime(issued.expiresAt, i18n.language) })}</p>
      <div className="flex items-center gap-2">
        <input className={FORM_CONTROL_CLASS} value={link} readOnly aria-label={t("projects.invitation.link")} onFocus={(event) => { event.target.select(); }} />
        <CopyReference value={link} label={t("projects.invitation.copyLink")} />
      </div>
      {withNote ? <p className={FORM_HELP_TEXT_CLASS}>{t("projects.invitation.shownOnce")}</p> : null}
    </div>
  );
}
